import { HttpError, useCreate } from '@refinedev/core';
import { MeetingNoteStatus } from './useCalendarEventMeetingNote';

type GenerateMeetingNoteInput = {
  templateId: string;
};

type GenerateMeetingNoteResponse = {
  status: MeetingNoteStatus;
  taskId?: string;
  meetingNoteId?: string;
};

type UseGenerateCalendarEventMeetingNoteResult = {
  generateMeetingNote: (input: GenerateMeetingNoteInput) => Promise<GenerateMeetingNoteResponse>;
  isLoading: boolean;
  error: HttpError | null;
};

export const useGenerateCalendarEventMeetingNote = (
  eventId: string,
): UseGenerateCalendarEventMeetingNoteResult => {
  const { mutateAsync, error, isLoading } = useCreate<
    GenerateMeetingNoteResponse,
    HttpError,
    GenerateMeetingNoteInput
  >({
    resource: `calendar-events/${eventId}/meeting-notes`,
  });

  const generateMeetingNote = async (
    input: GenerateMeetingNoteInput,
  ): Promise<GenerateMeetingNoteResponse> => {
    const result = await mutateAsync({
      values: input,
    });
    return result.data;
  };

  return {
    generateMeetingNote,
    isLoading,
    error,
  };
};
